// extracted by mini-css-extract-plugin
export var content = "_mp-1";
export var fullScreen = "_mp-0";